import { Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Subscription } from 'rxjs'

import { TranslateService } from '@ngx-translate/core'
import { SiteService } from '../../../services/site.service'
import { MessageService } from '../../../services/message.service'

interface ModalData {
	referenceNumber: string
	heading: string
	requestSummaryList: { key: string; value: string }[]
  }

@Component({
    selector: 'app-request-summary-modal',
    templateUrl: './request-summary-modal.component.html',
    styleUrls: ['./request-summary-modal.component.scss'],
    standalone: false
})
export class RequestSummaryModalComponent implements OnInit 
{
	loginSessionExpiredSubscription: Subscription

	referenceNumber: string = ''
	heading: string = ''

	constructor(
		public dialogRef: MatDialogRef<RequestSummaryModalComponent>, @Inject(MAT_DIALOG_DATA) public data: ModalData,
		private siteService: SiteService,
		private translateService: TranslateService,
		private messageService: MessageService
	) 
	{
		this.loginSessionExpiredSubscription = this.messageService.loginSessionExpired$.subscribe(() =>
		{
			this.closeModal()
		})
	}

	ngOnInit() 
	{
		if (this.data.referenceNumber && this.data.heading && this.data.requestSummaryList)
		{
			this.referenceNumber = this.data.referenceNumber
			this.heading = this.data.heading

			const tableBody = document.querySelector("#dataTable tbody");

			if (tableBody) 
			{
				this.data.requestSummaryList.forEach(item => {
					const row = document.createElement("tr")

					const keyCell = document.createElement("td")
					keyCell.textContent = item.key

					const spaceCell = document.createElement("td")
					spaceCell.textContent = '    '
					spaceCell.style.whiteSpace = 'pre'

					const valueCell = document.createElement("td")
					valueCell.textContent = item.value

					row.appendChild(keyCell)
					row.appendChild(spaceCell)
					row.appendChild(valueCell)
					tableBody.appendChild(row)
				})
			}
		}

	}

	closeModal(): void
	{
		this.dialogRef.close(false)
	}

	logout()
	{
		this.dialogRef.close(false)
	}

	extendSession()
	{
		this.dialogRef.close(true)
	}

	print(): void
	{
		this.siteService.printHtmlElement('printSummarySectionId', this.heading)
	}
}
